export function generateImport({contractName, address}) {
  return {contractName, address, contract: ""}
}
